import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=21891e8b&scoped=true"
import script from "./surveys.vue?vue&type=script&lang=ts"
export * from "./surveys.vue?vue&type=script&lang=ts"
import style0 from "./surveys.vue?vue&type=style&index=0&id=21891e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21891e8b",
  null
  
)

export default component.exports